/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{makeHandle as t}from"./handleUtils.js";function e(e){return{setTimeout:(o,r)=>{const i=e.setTimeout(o,r);return t(()=>e.clearTimeout(i))}}}const o=e(globalThis);export{o as clock,e as wrap};
